import { useForm } from '@mantine/form';
import { useState } from 'react';
import {
	validateNumber,
} from '../../../util/validation/commonValidation';
import type { UpsertProductPriceDto } from '../types/ProductPriceDto';

const defaultProduct: UpsertProductPriceDto = {
	skuid: '',
	branchId: 0,
	incVatPrice: 0,
	stockLevel: 0,
	branchName: '',
	minStock: 0,
	maxStock: 0
};

// Duplicate to useUpsertBranchStockForm.tsx - could be abstracted to a more generic useUpsertForm.tsx if needed 
export function useUpsertProductPriceForm(product: UpsertProductPriceDto = defaultProduct) {
	const [inputs, setInputs] = useState<UpsertProductPriceDto>(product);

	const form = useForm<UpsertProductPriceDto>({
		mode: 'uncontrolled',
		initialValues: product,
		validate: {
			incVatPrice: (v) =>
				validateNumber(v?.toString(), false, 0, 1000000, 'Price inc. VAT'),
			stockLevel: (value) =>
				validateNumber(
					value?.toString(),
					false,
					0,
					10000000,
					'Stock Level',
					false,
				),
			minStock: (v) =>
				validateNumber(
					v?.toString(),
					false,
					-1000000,
					1000000,
					'Minimum stock',
					false,
				),
			maxStock: (v) =>
				validateNumber(
					v?.toString(),
					false,
					-1000000,
					1000000,
					'Maximum stock',
					false,
				),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
